
import { defineComponent, ref, computed, PropType } from "vue";
import type { displayType } from "@/types/SurveyInfo";

export default defineComponent({
  name: "OneOfList",

  props: {
    text: String,
    choiceAnswer: Array,
    currentLang: String,
    customAnswer: Boolean,
    customTextAnswer: String,
    verticalLayout: Boolean,
    index: Number,
    type: {
      type: String as PropType<displayType | undefined>,
      required: false,
    },
  },

  emits: ["answersFields", "next-question"],

  setup(props, { emit }) {
    const radio = ref<string | { choiceRu: string; choiceKk: string }>("");
    const customAnswerS = ref<string>("");

    const centerNum = computed(() => {
      let arrLength = props.choiceAnswer?.length || 0;
      return Math.floor(arrLength / 2);
    });

    const answerChunk = computed(() => {
      const newArray = [];
      if (props.choiceAnswer?.length && props.choiceAnswer.length > 5) {
        for (let i = 0; i < props.choiceAnswer.length; i += centerNum.value) {
          newArray.push(props.choiceAnswer.slice(i, i + centerNum.value));
        }
      } else {
        newArray.push(props.choiceAnswer);
      }
      return newArray;
    });

    const handleSelection = (
      value: { choiceRu: string; choiceKk: string } | string
    ) => {
      if (value === "customAnswer") {
        customAnswerS.value = "";
        return; // Не отправляем ответ сразу
      }

      const answer =
        typeof value !== "string"
          ? props.currentLang === "RU"
            ? value.choiceRu
            : value.choiceKk
          : "";

      emit("answersFields", props.index, {
        singleAnswer: answer,
        customAnswer: "",
      });

      if (props.type === "ONE_PAGE") {
        emit("next-question");
      }
    };

    const submitCustomAnswer = () => {
      if (customAnswerS.value.trim() !== "") {
        emit("answersFields", props.index, {
          singleAnswer: "customAnswer",
          customAnswer: customAnswerS.value,
        });

        if (props.type === "ONE_PAGE") {
          emit("next-question");
        }
      }
    };

    return {
      radio,
      customAnswerS,
      centerNum,
      answerChunk,
      handleSelection,
      submitCustomAnswer,
    };
  },
});
